import { Plus, X } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import type { RecipeFormData } from '@/types/recipe'

export function RecipeFormIngredients() {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<RecipeFormData>()

  const ingredients = watch('ingredients')

  const appendIngredient = () => {
    setValue('ingredients', [...ingredients, ''])
  }

  const removeIngredient = (index: number) => {
    setValue(
      'ingredients',
      ingredients.filter((_, ingredientIndex) => ingredientIndex !== index)
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Ingrediënten</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {ingredients.map((ingredient, index) => (
            <div key={`ingredient-${index}-${ingredient}`} className="flex gap-2">
              <Input
                {...register(`ingredients.${index}`)}
                placeholder="Bijvoorbeeld: 400g spaghetti"
                className={errors.ingredients?.[index] ? 'border-red-500' : ''}
              />
              {ingredients.length > 1 ? (
                <Button type="button" variant="outline" size="sm" onClick={() => removeIngredient(index)}>
                  <X className="h-4 w-4" />
                </Button>
              ) : null}
            </div>
          ))}

          <Button type="button" variant="outline" onClick={appendIngredient} className="w-full">
            <Plus className="mr-2 h-4 w-4" />
            Ingrediënt Toevoegen
          </Button>
        </div>

        {errors.ingredients ? <p className="mt-1 text-sm text-red-500">{errors.ingredients.message as string}</p> : null}
      </CardContent>
    </Card>
  )
}
